// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"f1a7c60e","577":"4b83ba99","665":"cde2c2f1","787":"55695bd7"}[chunkId] + ".chunk.js";
};